import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {Observable, Subscription} from "rxjs";
import {ChartSeries} from "../chart-series";
import {ChartMemberSelection} from "../chart-member-selection";
import {MdxMemberUtil} from "../../mdx-member-util";
import {MeasureDataType} from "../../measure-data-type";
import {TranslateService} from "@ngx-translate/core";

/**
 * Displays series in a table
 */
@Component({
    selector: "bi-grid-chart",
    templateUrl: "./grid-chart.component.html",
    styleUrls: ["./grid-chart.component.scss"]
})
export class GridChartComponent implements OnInit, OnDestroy {

    MeasureDataType = MeasureDataType;

    /**
     * Listens for updates for series data
     */
    @Input() seriesData: Observable<ChartSeries[]>;
    @Input() title: string;
    @Input() height: number = 400;

    /**
     * Map of full qualified hierarchy names that map to logical child hierarchies.
     */
    @Input() childHierarchies: { [key: string]: string; };

    @Output() memberSelection: EventEmitter<any> = new EventEmitter();


    series: ChartSeries[];

    axisLabel: string = "";

    private subscription: Subscription;

    constructor(public translateService: TranslateService) {

    }

    ngOnInit(): void {

        this.subscription = this.seriesData.subscribe((seriesDataArr: ChartSeries[]) => {
            this.series = seriesDataArr;

            if (seriesDataArr && seriesDataArr.length > 0 && seriesDataArr[0].attribute) {
                const dimension: string = seriesDataArr[0].attribute.replace(/\[([^\]]*)].*/, "$1");
                const level: string = seriesDataArr[0].attribute.replace(/.*\[(.*)]$/, "$1");
                const key: string = "wbo.bi.dimension-key." + dimension + ";" + level;
                this.translateService.get(key).subscribe((translation: string) => {
                    this.axisLabel = translation;
                });
            }

        });
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    filter(): void {

    }

    selectSingle(index: number) {
        if (!this.series) {
            return;
        }

        if (!index) {
            index = 0;
        }
        const members: string [] = [];
        const labels: string[] = [];

        if (MdxMemberUtil.isMember(this.series[0].dataMembers[index])) {
            members.push(MdxMemberUtil.getHierarchyForMember(this.series[0].dataMembers[index], this.childHierarchies));
            labels.push(this.series[0].dataLabels[index]);
            this.memberSelection.emit(new ChartMemberSelection(this.title, members, labels));
        }
    }
}
